import { render } from "./DocumentNameLink.vue?vue&type=template&id=d61c4622&scoped=true"
import script from "./DocumentNameLink.vue?vue&type=script&lang=js"
export * from "./DocumentNameLink.vue?vue&type=script&lang=js"

import "./DocumentNameLink.vue?vue&type=style&index=0&id=d61c4622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61c4622"]])

export default __exports__